export function customSelect() {
    // if ($("select").length) {
    //     jcf.setOptions("Select", {
    //         wrapNative: false,
    //         fakeDropInBody: false,
    //         maxVisibleItems: 8
    //     });
    //
    //     jcf.replaceAll();
    // }
    // if ($(".jcf-scrollable").length) {
    //     jcf.replaceAll();
    // }

    // if (window.Drupal) {
    //     window.Drupal.behaviors.formCustomSelect = {
    //         attach: function () {
    //             if (window.Drupal.ajax) {
    //                 if ($("select").length) {
    //                     jcf.replaceAll();
    //                 }
    //                 if ($(".jcf-scrollable").length) {
    //                     jcf.replaceAll();
    //                 }
    //             }
    //         }
    //     };
    // }
}


// WEBPACK FOOTER //
// ./assets/js/modules/customSelect.js